export const ACTIONS = {
  MEMBER: {
    EDIT_TAGS: "Edit Tags",
    EDIT_NOTES: "Edit Notes",
    EDIT_TRIAL_EXPIRATION_DATE: "Edit Trial Expiration Date",
    GRANT_TRIAL_PERIOD: "Grant Trial Period",
    UPDATE_PROGRAM: "Update Program",
    UPDATE_STATUS_FREE: "Make Member Free",
    UPDATE_FEATURE_FLAGS: "Update Feature Flags",
    OPEN_CHAT: "Open Chat",
    OPEN_PROFILE: "Open Profile",
    OPEN_ENTITLEMENTS: "Open Entitlements",
    OPEN_ENTITLEMENT_CHANGE_TEAM: "Open Change Team Entitlement",
    AMPLITUDE: "Open Amplitude",
    COPY_ID: "Copy ID",
    SCRAMBLE_USER: "Scrable",
    UNSCRAMBLE_USER: "Unscrable",
  },
};

export const MEMBERS = "Members";

// Statuses where admins can grant/edit a trial. Trialers go through
// setUserTrialEnd (extend/shorten the existing trial); canceled members get a
// fresh trial period via createTrialPeriod (previously locked down; reopened
// so support can handle these without Bruno).
export const TRIAL_EDITABLE_MEMBERSHIP_STATUSES = [
  "trialing",
  "trialing expired",
  "canceled",
];
